import { render, staticRenderFns } from "./QuotationSelectInsuranceCompany.vue?vue&type=template&id=f2573bb8"
import script from "./QuotationSelectInsuranceCompany.vue?vue&type=script&lang=js"
export * from "./QuotationSelectInsuranceCompany.vue?vue&type=script&lang=js"
import style0 from "./QuotationSelectInsuranceCompany.vue?vue&type=style&index=0&id=f2573bb8&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports